import { render, staticRenderFns } from "./CoverMyMedsResponseComponent.vue?vue&type=template&id=77a9dc5f&scoped=true"
import script from "./CoverMyMedsResponseComponent.vue?vue&type=script&lang=ts"
export * from "./CoverMyMedsResponseComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a9dc5f",
  null
  
)

export default component.exports